<div class="dashboard__content mt-5 pb-5">
        <div class="row">
            <div class="col-12 mt-n4 mb-2">
                <span class="small text-muted">Winning Hands Admin</span>
                <span class="small text-muted">&nbsp;>&nbsp;</span>
                <a [routerLink]="[ '/', 'admin', 'dashboard' ]" class="small text-primary text-decoration-none"> Event Management</a>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-12">
                <h1 class="mb-0">EVENT MANAGEMENT</h1>
            </div>
        </div>


        <form [formGroup]="eventForm" class="therapist__form">
            <div class="row g-4">
                <div class="col-lg-10 col-12">
                    <mat-form-field hideRequiredMarker="true" class="example-form-field w-100" appearance="outline">
                        <mat-label>EVENT NAME</mat-label>
                        <input formControlName="eventName" matInput type="text">
                    </mat-form-field>
                </div>
                <div class="col-lg-2 col-12">

                    <button [disabled]="!eventForm.dirty" mat-flat-button color="primary" class="w-100" type="button"
                        (click)="saveEventName()">EDIT NAME</button>


                </div>

            </div>
        </form>

        <div class="row g-4 mt-4 mb-3">
            <div class="col">
                <h3>THERAPISTS</h3>
            </div>
            <div class="col-auto">
                <button mat-flat-button (click)="goToTherapists(0);" color="accent">MANAGE THERAPISTS</button>
            </div>
        </div>

        <div class="row g-4">
            <div class="col-12">
                <div class="row g-4">



                    <div class="col-lg-3 col-12">
                        <a mat-button (click)="goToClockedIn()" class="card dashboard__card p-4">
                            <div class="row">
                                <div class="col-auto d-flex align-items-center justify-content-center">
                                    <span class="material-symbols-outlined">alarm</span>
                                </div>
                                <div class="col">
                                    <h3 class="mb-0">{{dashboardAdminModel.clockedInCount}}</h3>
                                    <p class="mb-0">CLOCKED IN</p>
                                </div>
                            </div>

                        </a>
                    </div>

                    <div class="col-lg-3 col-12">
                        <a (click)="goToOnBreak()"  mat-button class="card dashboard__card p-4">
                            <div class="row">
                                <div class="col-auto d-flex align-items-center justify-content-center">
                                    <span class="material-symbols-outlined">coffee</span>
                                </div>
                                <div class="col">
                                    <h3 class="mb-0">{{dashboardAdminModel.therapistsOnBreak}}</h3>
                                    <p class="mb-0">ON BREAK</p>
                                </div>
                            </div>

                        </a>
                    </div>

                    <div class="col-lg-3 col-12">
                        <a (click)="goToOnMassage()"  mat-button class="card dashboard__card p-4">
                            <div class="row">
                                <div class="col-auto d-flex align-items-center justify-content-center">
                                    <span class="material-symbols-outlined">massage</span>
                                </div>
                                <div class="col">
                                    <h3 class="mb-0">{{dashboardAdminModel.onMassageCount}}</h3>
                                    <p class="mb-0">ON MASSAGE</p>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-lg-3 col-12">
                        <a (click)="goToWaiting()"  mat-button class="card dashboard__card p-4">
                            <div class="row">
                                <div class="col-auto d-flex align-items-center justify-content-center">
                                    <span class="material-symbols-outlined">hourglass</span>
                                </div>
                                <div class="col">
                                    <h3 class="mb-0">{{dashboardAdminModel.waiting}}</h3>
                                    <p class="mb-0">WAITING</p>
                                </div>
                            </div>
                        </a>
                    </div>


                </div>
            </div>
        </div>

        <div class="row g-4 mt-4 mb-3">
            <div class="col">
                <h3>BOOKINGS</h3>
            </div>
            <div class="col-auto">
                <button mat-flat-button (click)="goToBookings(0)" color="accent">MANAGE BOOKINGS</button>
            </div>
        </div>



        <div class="row g-4">

            <div class="col-lg-3 col-12">
                <a (click)="goToBookings(2)" mat-button class="card dashboard__card p-4">
                    <div class="row">
                        <div class="col-auto d-flex align-items-center justify-content-center">
                            <span class="material-symbols-outlined">back_hand</span>
                        </div>
                        <div class="col">
                            <h3 class="mb-0">{{dashboardAdminModel.bookingsInQueue}}</h3>
                            <p class="mb-0">QUEUE LENGTH</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-lg-3 col-12">
                <a (click)="goToBookings(5)" mat-button class="card dashboard__card p-4">
                    <div class="row">
                        <div class="col-auto d-flex align-items-center justify-content-center">
                            <span class="material-symbols-outlined">sync</span>
                        </div>
                        <div class="col">
                            <h3 class="mb-0">{{dashboardAdminModel.bookingsInProgress}}</h3>
                            <p class="mb-0">IN PROGRESS</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-lg-3 col-12">
                <a (click)="goToBookings(6)" mat-button class="card dashboard__card p-4">
                    <div class="row">
                        <div class="col-auto d-flex align-items-center justify-content-center">
                            <span class="material-symbols-outlined">check</span>
                        </div>
                        <div class="col">
                            <h3 class="mb-0">{{dashboardAdminModel.bookingsCompleted}}</h3>
                            <p class="mb-0">COMPLETED</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-lg-3 col-12">
                <a (click)="goToBookings(7)" mat-button class="card dashboard__card p-4">
                    <div class="row">
                        <div class="col-auto d-flex align-items-center justify-content-center">
                            <span class="material-symbols-outlined">block</span>
                        </div>
                        <div class="col">
                            <h3 class="mb-0">{{dashboardAdminModel.bookingsCancelled}}</h3>
                            <p class="mb-0">CANCELLED</p>
                        </div>
                    </div>
                </a>
            </div>
        </div>
</div>